import React from "react";
import DashboardV2 from "./DashboardV2";

const Dashboard: React.FC = () => {
  return <DashboardV2 />;
};

export default Dashboard;
